import * as Sentry from "@sentry/react";
import getSentryConfig from "./sentryConfig";

function debugLog(...msgArr) {
  if (window.LOCAL_DEV) {
	console.debug(...msgArr);
  }
}

if (window.SENTRY_DSN) {
  const config = getSentryConfig(Sentry)
  if (!Sentry.getClient()) {
	Sentry.init(config);
	debugLog("Initialized Sentry with", config, Sentry);
  }
} else if (!window.LOCAL_DEV) {
  console.warn("Sentry error logging disabled");
}
export { Sentry };
